/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./menuPage.vue?vue&type=template&id=7ff593cc&scoped=true"
import script from "./menuPage.vue?vue&type=script&lang=js"
export * from "./menuPage.vue?vue&type=script&lang=js"
import style0 from "./menuPage.vue?vue&type=style&index=0&id=7ff593cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff593cc",
  null
  
)

export default component.exports